module.exports = __webpack_public_path__ + "static/media/key_image.89569471.png";